// extracted by mini-css-extract-plugin
export var benefitLink = "project-card-module--benefitLink--1600e";
export var benefitList = "project-card-module--benefitList--6730e";
export var benefitsContainer = "project-card-module--benefitsContainer--36b5c";
export var carouselContainer = "project-card-module--carouselContainer--fb19e";
export var code = "project-card-module--code--926ce";
export var content = "project-card-module--content--e860e";
export var fullStory = "project-card-module--fullStory--7eadc";
export var iconDigital = "project-card-module--iconDigital--11ca4";
export var iconFuel = "project-card-module--iconFuel--d823a";
export var iconMoney = "project-card-module--iconMoney--03198";
export var iconTime = "project-card-module--iconTime--0ff64";
export var iconTrees = "project-card-module--iconTrees--d5eba";
export var partnerContainer = "project-card-module--partnerContainer--13170";
export var partnerContainerWrapper = "project-card-module--partnerContainerWrapper--1c377";
export var partnerLogos = "project-card-module--partnerLogos--97f3f";
export var project = "project-card-module--project--a285a";
export var projectBlock = "project-card-module--projectBlock--1e9d2";
export var projectBlockBackground = "project-card-module--projectBlockBackground--b6a43";
export var projectContainer = "project-card-module--projectContainer--08f91";
export var projectTitle = "project-card-module--projectTitle--5e6cb";
export var readMore = "project-card-module--readMore--89bf7";